import { createFileRoute } from '@tanstack/react-router';

import { scratchpadSearchSchema } from '@apps/web/features/admin_agent_scratchpad/model/search_params';
import { ScratchpadIndexPage } from '@apps/web/features/admin_agent_scratchpad/ui/index_page';

export const Route = createFileRoute('/_app/admin/agent/(notes)/notes/')({
    component: ScratchpadIndexRoute,
    validateSearch: scratchpadSearchSchema,
    head: () => ({
        meta: [{ title: 'Notes | Internal Admin Agent' }],
    }),
});

function ScratchpadIndexRoute() {
    const search = Route.useSearch();
    return <ScratchpadIndexPage search={search} />;
}
